module.exports = __webpack_public_path__ + "img/29_16.734e3e36.png";